import React from "react";
import { StatusDropdown } from "components";
import LabelledDivRow from "components/LabelledDivRow";
import { type ShowDates } from "components/showdatepicker/models";
import ShowDatePicker from "components/showdatepicker/ShowDatePicker";
import TimeOfPerformance from "components/showdatepicker/TimeOfPerformance";
import UrlInput from "components/urlinput";
import { Input } from "semantic-ui-react";
import ArtistPicker from "components/ArtistPicker/ArtistPicker";
import ProductionModalPicker from "components/Picker/ProductionPicker/ProductionModalPicker";

interface Props {
  production: server.dto.ProductionSmallV2
  onProductionChanged: (production: server.dto.ProductionSmallV2) => void

  readonlyArtist: boolean
  artist: server.dto.ArtistSmall
  onArtistChanged: (artist: server.dto.ArtistSmall) => void

  dates: ShowDates
  onDatesChanged: (newDates: ShowDates, hasErrors: boolean) => void
  onTimeOfPerformanceChanged: (newTimeOfPerformance: string) => void

  status: server.dto.StatusSmall
  onStatusChanged: (status: server.dto.StatusSmall) => void

  initialEventName: string
  onEventNameChanged: (eventName: string) => void

  eventWebsite: string
  onEventWebsiteChanged: (eventWebsite: string) => void

  statuses: server.dto.StatusSmall[]
}

const MainDetailsPanel = (props: Props) => {
  const [eventName, setEventName] = React.useState(props.initialEventName ?? "");

  return <>
    {site.currentEnvironment.production.enabled &&
      <LabelledDivRow label={site.currentEnvironment.production.singular}>
        <ProductionModalPicker
          value={props.production}
          onChange={props.onProductionChanged}
          canCreateNew={false}
          validatorKey="production"
          required={false}
        />
      </LabelledDivRow>}

    {site.currentEnvironment.functionGroups.artist.enabled &&
      <LabelledDivRow label={site.currentEnvironment.functionGroups.artist.singular}>
        {!props.readonlyArtist && <ArtistPicker
          value={props.artist}
          onChanged={props.onArtistChanged}
          filter="limitByUserAccess"
          selectFirstArtist
        />}
        {props.readonlyArtist && <div>{props.artist?.name}</div>}
      </LabelledDivRow>}

    <LabelledDivRow label={RESX.DateTime.lblDate}>
      <ShowDatePicker
        validatorKey="showDates"
        dates={props.dates}
        onDatesChanged={props.onDatesChanged}
      />
    </LabelledDivRow>

    <LabelledDivRow label={RESX.Show.TimeOfPerformance}>
      <TimeOfPerformance
        showDates={props.dates}
        onTimeOfPerformanceChanged={props.onTimeOfPerformanceChanged}
      />
    </LabelledDivRow>

    <LabelledDivRow label={RESX.Status.resxStatus}>
      <StatusDropdown
        options={props.statuses}
        value={props.status}
        onChange={props.onStatusChanged}
        mainArea="show"
      />
    </LabelledDivRow>

    <LabelledDivRow label={RESX.Show.NameOfEvent}>
      <Input
        fluid
        maxLength={serverReference.constants.show.maxEventNameLength}
        value={eventName}
        onChange={(_, { value }) => { setEventName(value); }}
        onBlur={() => { props.onEventNameChanged(eventName); }}
      />
    </LabelledDivRow>

    <LabelledDivRow label={RESX.Show.EventWebsite}>
      <UrlInput
        value={props.eventWebsite}
        onValueChange={props.onEventWebsiteChanged}
        validatorKey="eventWebsite"
        maxLength={serverReference.constants.url.maxUrlLength}
      />
    </LabelledDivRow>
  </>;
};

export default MainDetailsPanel;